import PropTypes from "prop-types";
import { CustomContainer, Form, Col } from "../../../DependencyHelper";
import { africaCountryCode } from "../../../../../utils/helperServices";
import formStyles from "../../NewLineForms.module.scss";
import DropDown from "../../dropDown/DropDown";

const EmploymentDetailsForm = ({
  formName,
  fieldValues,
  fieldErrors,
  fieldErrorsMessage,
  onChangeHandler,
  employmentTypes,
  employmentCategories,
  occupations,
  salaryDates,
  onResetHandler,
  onBlurHandler,
}) => {
  const handleChange = (event) => {
    onChangeHandler(event, null, formName);
  };

  const handleBlur = (event) => {
    onBlurHandler(event, null, formName);
  };

  return (
    <CustomContainer className={`${formStyles["main-container"]}`}>
      <Form.Row className={`${formStyles["main-row"]}`}>
        <>
          <Form.Group
            as={Col}
            sm="12"
            md="12"
            className={formStyles["form-group"]}
            controlId={`validationFormed102`}
          >
            <Form.Label
              className={formStyles["form-label"]}
              id={`validationFormed102-label`}
            >
              Employment Type
            </Form.Label>
            <DropDown
              formName={formName}
              name="employmentType"
              label="Employment type"
              data={employmentTypes}
              required={true}
              handleBlur={handleBlur}
              handleSelect={onChangeHandler}
              handleReset={onResetHandler}
              resetRequired={true}
              selectedId={fieldValues["employmentType"]}
              customId={`validationFormed102`}
              fieldError={fieldErrors["employmentType"]}
            />

            {fieldErrors["employmentType"] && (
              <Form.Control.Feedback
                type="invalid"
                className={`${formStyles["invalid-feedback"]} ${formStyles["error"]}`}
              >
                {fieldErrorsMessage["employmentType"]}
              </Form.Control.Feedback>
            )}
          </Form.Group>

          <Form.Group
            as={Col}
            sm="12"
            md="12"
            className={formStyles["form-group"]}
            controlId={`validationFormed103`}
          >
            <Form.Label
              className={formStyles["form-label"]}
              id={`validationFormed103-label`}
            >
              Employment category
            </Form.Label>
            <DropDown
              formName={formName}
              name="employmentCategory"
              label="Employment category"
              data={employmentCategories}
              required={true}
              handleBlur={handleBlur}
              handleSelect={onChangeHandler}
              selectedId={fieldValues["employmentCategory"]}
              customId={`validationFormed103`}
              handleReset={onResetHandler}
              resetRequired={true}
              fieldError={fieldErrors["employmentCategory"]}
            />

            {fieldErrors["employmentCategory"] && (
              <Form.Control.Feedback
                type="invalid"
                className={`${formStyles["invalid-feedback"]} ${formStyles["error"]}`}
              >
                {fieldErrorsMessage["employmentCategory"]}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <Form.Group
            as={Col}
            sm="12"
            md="12"
            className={formStyles["form-group"]}
            controlId={`validationFormed101`}
          >
            <Form.Label
              className={formStyles["form-label"]}
              id={`validationFormed101-label`}
            >
              Employer name
            </Form.Label>
            <Form.Control
              type="text"
              name="employerName"
              value={fieldValues["employerName"]}
              placeholder="Add your employer's name"
              required
              onChange={handleChange}
              onBlur={handleBlur}
              isInvalid={fieldErrors["employerName"]}
              className={
                fieldErrors["employerName"] ? formStyles["invalid"] : ""
              }
            />
            <Form.Control.Feedback
              type="invalid"
              className={formStyles["invalid-feedback"]}
            >
              {fieldErrorsMessage["employerName"]}
            </Form.Control.Feedback>
          </Form.Group>

          {fieldValues["employmentCategory"] !== "PEN" && (
            <Form.Group
              as={Col}
              sm="12"
              md="12"
              className={formStyles["form-group"]}
              controlId={`validationFormed1011`}
            >
              <Form.Label
                className={formStyles["form-label"]}
                id={`validationFormed1011-label`}
              >
                Employer telephone number
              </Form.Label>
              <Form.Control
                type="text"
                name="employerNumber"
                value={fieldValues["employerNumber"]}
                placeholder="Add your employer's number"
                required
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={fieldErrors["employerNumber"]}
                className={
                  fieldErrors["employerNumber"] ? formStyles["invalid"] : ""
                }
                maxLength={
                  africaCountryCode(fieldValues["employerNumber"]) ? "11" : "10"
                }
              />
              <Form.Control.Feedback
                type="invalid"
                className={formStyles["invalid-feedback"]}
              >
                {fieldErrorsMessage["employerNumber"]}
              </Form.Control.Feedback>
            </Form.Group>
          )}

          <Form.Group
            as={Col}
            sm="12"
            md="12"
            className={formStyles["form-group"]}
            controlId={`validationFormed104`}
          >
            <Form.Label
              className={formStyles["form-label"]}
              id={`validationFormed104-label`}
            >
              Occupation
            </Form.Label>
            <DropDown
              formName={formName}
              name="occupation"
              label="Occupation"
              data={occupations}
              required={true}
              handleBlur={handleBlur}
              handleSelect={onChangeHandler}
              selectedId={fieldValues["occupation"]}
              customId={`validationFormed104`}
              handleReset={onResetHandler}
              resetRequired={true}
              fieldError={fieldErrors["occupation"]}
            />

            {fieldErrors["occupation"] && (
              <Form.Control.Feedback
                type="invalid"
                className={`${formStyles["invalid-feedback"]} ${formStyles["error"]}`}
              >
                {fieldErrorsMessage["occupation"]}
              </Form.Control.Feedback>
            )}
          </Form.Group>

          <Form.Group
            as={Col}
            sm="6"
            md="6"
            className={formStyles["form-group"]}
            controlId={`validationFormed105`}
          >
            <Form.Label
              className={formStyles["form-label"]}
              id={`validationFormed105-label`}
            >
              Salary Date
            </Form.Label>
            <DropDown
              formName={formName}
              name="salaryDate"
              label="Salary date"
              data={salaryDates}
              required={true}
              handleBlur={handleBlur}
              handleSelect={onChangeHandler}
              selectedId={fieldValues["salaryDate"]}
              customId={`validationFormed105`}
              handleReset={onResetHandler}
              resetRequired={true}
              fieldError={fieldErrors["salaryDate"]}
            />

            {fieldErrors["salaryDate"] && (
              <Form.Control.Feedback
                type="invalid"
                className={`${formStyles["invalid-feedback"]} ${formStyles["error"]}`}
              >
                {fieldErrorsMessage["salaryDate"]}
              </Form.Control.Feedback>
            )}
          </Form.Group>

          <Form.Group
            as={Col}
            sm="12"
            md="12"
            className={formStyles["form-group"]}
            controlId={`validationFormed106`}
          >
            <Form.Label
              className={formStyles["form-label"]}
              id={`validationFormed106-label`}
            >
              Gross monthly salary
            </Form.Label>
            <Form.Control
              type="text"
              name="grossMonthlySalary"
              value={fieldValues["grossMonthlySalary"]}
              placeholder="Add your gross monthly salary"
              required
              onChange={handleChange}
              onBlur={handleBlur}
              isInvalid={fieldErrors["grossMonthlySalary"]}
              className={
                fieldErrors["grossMonthlySalary"] ? formStyles["invalid"] : ""
              }
            />
            <Form.Control.Feedback
              type="invalid"
              className={formStyles["invalid-feedback"]}
            >
              {fieldErrorsMessage["grossMonthlySalary"]}
            </Form.Control.Feedback>
            {!fieldErrors["grossMonthlySalary"] && (
              <div
                className={`${formStyles["hint-text"]} ${formStyles["hint-text-spacing"]}`}
              >
                {"This is your total monthly salary before deduction"}
              </div>
            )}
          </Form.Group>
        </>
      </Form.Row>
    </CustomContainer>
  );
};

EmploymentDetailsForm.propTypes = {
  formName: PropTypes.string,
  fieldValues: PropTypes.object,
  fieldErrors: PropTypes.object,
  fieldErrorsMessage: PropTypes.object,
  onChangeHandler: PropTypes.func,
  employmentTypes: PropTypes.array,
  employmentCategories: PropTypes.array,
  occupations: PropTypes.array,
  salaryDates: PropTypes.array,
};

EmploymentDetailsForm.defaultProps = {
  fieldValues: {},
  fieldErrors: {},
  fieldErrorsMessage: {},
  employmentTypes: [],
  employmentCategories: [],
  occupations: [],
  salaryDates: [],
};

export default EmploymentDetailsForm;
